

(function () {
    angular.module('send-email-action.dir', ['journey.veil', 'ngSanitize'])
        .directive('sendEmailAction', ['$rootScope', '$compile', '$templateCache', '$q', 'plumbService', 'helpers', 'canvasService', 'CANVAS_OPTS', '$stateParams', '$timeout', 'scrollLoaderEmails',  sendEmailAction]);


    function sendEmailAction($rootScope, $compile, $templateCache, $q ,plumbService, helpers, canvasService, CANVAS_OPTS, $stateParams, $timeout, scrollLoaderEmails) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.search = {};
                $scope.wasSave = false;

                //Function to emit Add Wait Time msg to the user when adding the send email node. Creating or Reusing.
                $scope.$watch('connections.data.emailStatus', function(){
                    if ($scope.connections != undefined) {
                        var emailStatusCheck = $scope.connections.data.emailStatus;
                        if ($stateParams.emailId && $stateParams.status && emailStatusCheck === 'fromEditor'){
                            $rootScope.$emit('coach-register', 'tipSendEmail');
                        }
                    }
                });

                $scope.saveData = function (displayUpdate) {
                    $scope.isDummyData();
                    $scope.connections.emailData.TemplateContent = '';
                    $scope.connections.emailData.TemplateText = '';

                    //Updates the parent to register its children
                    var parentData = helpers.getConnectionById($scope.connections.parent);
                    if (parentData) {
                        parentData.children = [];
                        parentData.children.push($scope.connections.id);
                        helpers.updateConnections(parentData);
                    }
                    //Save to the global canvas object
                    helpers.updateConnections($scope.connections);

                    var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                    if (index > -1) {
                        $rootScope.unsavedData.splice(index, 1);
                    }

                    $scope.selectedView = false;
                    //Displays action menu
                    $scope.displaySubMenu = false;
                    //Hides Error
                    $scope.displayError = false;
                    //Save Journey to template
                    canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);

                    if (!displayUpdate) {
                        $scope.wasSave = true;
                        $timeout(() => {
                            $scope.wasSave = false;
                        }, 1500);
                    }
                    //Set Back to autoSave
                    $scope.isElegibleForUpdate = true;
                    //Remove Activate Error since its being able to save
                    $scope.displayActivateError = false;
                    $scope.displayErrorBlink = false;

                    if($scope.reuse) {
                        $scope.reuse = false;
                        $rootScope.$emit('coach-register', 'tipSendEmail');
                    }

                    $rootScope.$emit('emailUpdated',  $scope.connections.id);

                    // Generates a wait time node
                    $rootScope.$emit('generateWaitTime', $scope.connections.id);

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                $scope.isDummyData = function() {
                    if($scope.connections.isDummy) {
                        if($scope.connections.data.emailId !== '11111111') {
                            delete $scope.connections.isDummy;
                        }
                    }
                };

                $scope.$watch('connections.emailData.EmailName', function(newVal, oldVal) {
                    if(newVal && newVal !== oldVal) {
                        if($scope.didReuse) {
                            $scope.didReuse = false;
                        }
                        else {
                            $scope.emailChanged = true;
                        }
                    }
                });

                const checkPermissionReminder = () => {
                    if (!$scope.connections.data.permisionReminder) {
                        return false;
                    }
                    else if ($scope.connections.emailData.PermissionReminderMessage !== '') {
                        return false;
                    } else {
                        return true;
                    }
                };

                $scope.emailChanged = false;
                $scope.validateFields = function() {
                    var deferred = $q.defer();
                    var partialRes;
                    var emailName = $scope.connections.emailData.EmailName;
                    var emailStatus = $scope.connections.data.emailStatus;

                    if (emailStatus === "fromEditor") {
                        $scope.storedEmailName = emailName;
                    }

                    if (!$scope.connections.emailData.Subject || !emailName || !$scope.connections.emailData.FromName || !$scope.connections.emailData.FromEmail || !$scope.connections.emailData.ReplyEmail || checkPermissionReminder()) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                        $scope.sbjErr = ($scope.connections.emailData.Subject === '');
                        $scope.eNameErr = (emailName === '');
                        $scope.eFromErr = ($scope.connections.emailData.FromName === '');
                        $scope.eFromSubjErr = ($scope.connections.emailData.FromEmail === '');
                        $scope.eFromReplyErr = ($scope.connections.emailData.ReplyEmail === '');
                        $scope.ePermissionReminder = ($scope.connections.emailData.PermissionReminderMessage === '');
                        $rootScope.$emit('sendEmailBackMenu');
                        partialRes = true;
                    }

                    if( ($scope.connections.data.permisionReminder && !$scope.connections.emailData.PermissionReminderMessage)|| ($scope.connections.data.googleAnalyticsAllUrl && !$scope.connections.emailData.GoogleAnalyticsCampaign) || ($scope.connections.data.pageTextTextarea && !$scope.connections.emailData.InboxPreviewText) ) {
                        $scope.permError = $scope.connections.emailData.PermissionReminderMessage === '' && $scope.connections.data.permisionReminder;
                        $scope.analyticsError = $scope.connections.emailData.GoogleAnalyticsCampaign === '' && $scope.connections.data.googleAnalyticsAllUrl;
                        $scope.pgTextError = $scope.connections.emailData.InboxPreviewText  === '' && $scope.connections.data.pageTextTextarea;
                        partialRes = $scope.analyticsError || $scope.permError || $scope.pgTextError || partialRes;
                    }

                    if(!partialRes && emailStatus != "fromEditor" && emailStatus != "insertExisting") {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index === -1) {
                                $rootScope.unsavedData.push($scope.connections.id);
                            }

                            $scope.sbjErr = $scope.eNameErr = $scope.eFromErr = $scope.eFromSubjErr = $scope.eFromReplyErr = $scope.ePermissionReminder = false;
                            $scope.permError = $scope.analyticsError = $scope.pgTextError = false;

                            if ((emailStatus === "updateEmail" && $scope.emailChanged) || (emailStatus === "createNew" && $scope.storedEmailName != emailName)) {
                                canvasService
                                .validateDuplicateEmailName(emailName)
                                .success(function(res){

                                    if (res.IsUniqueName) {
                                        deferred.resolve();
                                        $scope.eNameErr = false;
                                        $scope.storedEmailName = emailName;
                                        $scope.emailChanged = false;
                                    }else {
                                        $rootScope.$emit('errorMsg',$scope.translate('canvas.action.sendEmail.duplicateEmailName'));
                                        $scope.eNameErr = true;
                                        deferred.reject();
                                        $rootScope.$emit('sendEmailBackMenu');
                                    }
                                })
                                .error(function (err) {
                                    var error = err.Message || $scope.translate('canvas.error.601');
                                    //Error msg from backend when failing
                                    $rootScope.$emit('errorMsg', error);
                                    deferred.reject();
                                    $scope.eNameErr = true;
                                });
                            } else {
                                $rootScope.$emit('cleanSendEmailErrors');
                                deferred.resolve();
                            }

                        }else {
                            deferred.reject();
                        }
                    return deferred.promise;
                };

                //When we save a the form
                $scope.save = function (trackAddWaitTimeMsg) {
                    //If form data is missing
                    $scope.validateFields().then(function(){
                        if ($scope.connections.data.emailStatus === 'createNew') {
                            // when creating a new email
                            $rootScope.editorSubMenu = true;
                            $scope.displayList = false;
                            $rootScope.$emit('hideActionSendEmailModal');
                        } else if ($scope.connections.data.emailStatus === 'updateEmail') {
                            // this is an update email action
                            canvasService
                                .updateEmailData($scope.connections.data.emailId, $scope.connections.emailData)
                                .success(function (id) {
                                    $scope.ePermissionReminder = true;
                                    if (id) {
                                        $scope.saveData(true);
                                        $rootScope.editorSubMenu = false;
                                        $timeout(function() {
                                            $scope.displayList = false;
                                            $rootScope.$emit('hideActionSendEmailModal');
                                        }, 0);
                                    }
                                })
                                .error(function (err) {

                                });
                        }
                    }).catch(function() {
                            var errors = {
                                sbjErr: $scope.sbjErr,
                                eNameErr: $scope.eNameErr,
                                eFromErr: $scope.eFromErr,
                                eFromSubjErr: $scope.eFromSubjErr,
                                eFromReplyErr: $scope.eFromReplyErr,
                                permError: $scope.permError,
                                analyticsError: $scope.analyticsError,
                                pgTextError: $scope.pgTextError,
                                ePermissionReminder: $scope.ePermissionReminder
                            };

                            $rootScope.$emit('displayActionSendEmailModalError', errors);

                            if($scope.tempConn) {
                                $scope.connections = angular.copy($scope.tempConn);
                            }

                            for (const key in errors) {
                                if (errors[key]) {
                                    $rootScope.scrollTarget = key;
                                    break;
                                }
                            }

                            $timeout(() => { $rootScope.scrollTarget = '' }, 500);
                        });
                };

                $scope.onRedirect = function () {
                    // when redirection is back
                    if ($stateParams.emailId) {
                        $scope.insertExisting($stateParams.emailId, true);
                        canvasService.generateThumbs($stateParams.emailId).then(() => {});
                    }
                };

                $scope.setLastElem = function(evt) {
                    var elemId = $(evt.target).parents('div.shape').attr('id');
                    plumbService.setLastElemClicked(elemId);
                };

                $scope.toggleConnectionMenu = function (event) {
                    //Check if form data is filled and a connection exists as only one is allowed
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.605'));
                    }
                    else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                            $scope.displaySubMenu = true;

                            $scope.modalWindow = false;
                            $scope.$broadcast('setMenuDefaults');
                            //Element position on screen when creating a new email
                        } else {
                            if (!$scope.connections.data.emailId) {
                                $scope.displayModal();
                                $scope.displaySubMenu = false;
                            } else if ($scope.displaySubMenu === false) {
                                $scope.$broadcast('setMenuDefaults');
                                $scope.displaySubMenu = true;

                                $scope.modalWindow = false;
                            }
                            else {
                                $scope.displaySubMenu = false;

                                $scope.modalWindow = false;
                            }
                        }
                    }
                };

                $scope.config = function (evt) {
                    var type = 'displayList';
                    if ($scope.connections.data.emailId) {
                        $scope[type] = false;
                        type = 'selectedView';
                    }

                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if (newTop !== $scope.connections.top || $scope.connections.left !== newLeft) {
                        $scope.displayList = false;
                        //update rootScope position

                        helpers.updatePos($scope.connections.id, newTop, newLeft);

                        $scope.connections.top = newTop;
                        $scope.connections.left = newLeft;

                        $rootScope.$emit('hideActionSendEmailModal');
                        return false;
                    }

                    if ($rootScope.editorSubMenu) {
                        $rootScope.editorSubMenu = false;
                        $scope.displayList = true;
                        $rootScope.$emit('displayActionSendEmailModal', $scope.connections, true, false);

                        if($scope.connections.data.emailId) {
                            $scope.connections.data.emailStatus = 'updateEmail';
                        } else {
                            $scope.connections.data.emailStatus = 'createNew';

                        }
                    } else {
                        if($scope.connections.isDummy){
                            $rootScope.$emit('displayModalSendEmail' + $scope.connections.id);
                        } else {
                            //Show form menu
                            $scope.selectedView = false;
                            $scope[type] = !$scope[type];
                            $rootScope.$emit('displayActionSendEmailModal', $scope.connections, $scope.displayList, $scope.selectedView);
                        }
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.showTipModal = () => {
                    // last options is for is tip modal.
                    $rootScope.$emit('displayActionSendEmailModal', $scope.connections, false, false, true);
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displaySubMenu) {
                        $scope.displayList = false;
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.parseDescription = function (desc) {

                    if (desc) {
                        if ( desc.length > 15) {
                            desc = desc.slice(0, 15) + '...';
                        //Desc < 15
                        }  else if (desc.length < 15) {
                            desc = desc;
                        }
                    } else {
                        return $scope.translate('commons.enterDetails');
                    }

                    return desc;
                };

                $scope.hideModal = function () {
                    $scope.modalWindow = false;
                    $scope.displayList = false;
                    $scope.search.email = "";
                    $scope.emailList = $rootScope.emailData;

                    var node = _.find($rootScope.connections, function (conn) {
                        return conn.id === $scope.connections.id;
                    });

                    if (!node) {
                        $scope.deleteElement();
                    }
                };

                $scope.saveDuplicate = function () {
                    if ($scope.duplicateName) {
                        $scope.duplicateError = false;
                        $scope.didReuse = false;
                        $scope.reuse = false;
                        $scope.duplicating = true;

                        var mergeTags = helpers.getMergeTags() || [];
                        //Once the service is ready
                        canvasService
                            .duplicateEmail($scope.currentDuplicateEmailId, $scope.duplicateName, mergeTags)
                            .success(function (res) {
                                var d = new Date(),
                                    createdDate = d.getMonth() + ' ' + d.getDate() + ', ' + d.getFullYear(),
                                    mergeTags = helpers.getMergeTags() || [];

                                $scope.didReuse = true;
                                $scope.reuse = true;
                                $scope.duplicateName = "";
                                $scope.duplicateModal = !$scope.duplicateModal;
                                $scope.emailList.push({
                                    EmailTemplateCreatedDate: res.CreatedDate || createdDate,
                                    EmailTemplateId: res.Id,
                                    EmailTemplateName: res.EmailName
                                });

                                $scope.connections.data.emailStatus = 'insertExisting';
                                $scope.connections.data.emailId = res.Id;
                                $scope.connections.data.emailName = res.EmailName;
                                $scope.connections.emailData = {
                                    EmailName: res.EmailName,
                                    FromEmail: res.FromEmail,
                                    FromName: res.FromName,
                                    GoogleAnalyticsCampaign: res.GoogleAnalyticsCampaign,
                                    PermissionReminderMessage: res.PermissionReminderMessage,
                                    ReplyEmail: res.ReplyEmail || res.FromEmail,
                                    Subject: res.Subject,
                                    TemplateContent: res.TemplateContent,
                                    InboxPreviewText : res.InboxPreviewText,
                                    ToListName: res.ToListName,
                                    ToListId: res.ToListId + '',
                                    WebpageVersion: res.WebpageVersion,
                                    Version: res.Version,
                                    Reuse: $scope.reuse
                                };

                                if(!$scope.connections.emailData.PermissionReminderMessage) {
                                    $scope.connections.emailData.PermissionReminderMessage = $scope.translate('canvas.action.sendEmail.permisionReminder1') + $rootScope.cSettings.ClientCompany + $scope.translate('canvas.action.sendEmail.permisionReminder2');
                                    $scope.connections.data.permisionReminder = true;
                                }

                                $scope.displayList = $rootScope.editorSubMenu = $scope.modalWindow = false;

                                if ($scope.isFromEditor) {
                                    $scope.selectedView = false;
                                } else {

                                    $scope.selectedView = true;
                                    $rootScope.$emit('displayActionSendEmailModal', $scope.connections, false, true);
                                }
                                //Hide Extra veils top and header
                                $scope.duplicating = false;
                                canvasService.generateThumbs(res.Id).then(() => {});
                            })
                            .error(function (err) {
                                if(err.ErrorType === "Duplicate") {
                                    err.Message = $scope.translate('canvas.action.sendEmail.duplicateEmailName');
                                }

                                $rootScope.$emit('errorMsg', err.Message);
                                $scope.duplicateName = "";
                                $scope.duplicating = false;
                            });
                    } else {
                        $scope.duplicateError = true;
                    }
                };

                //Display Duplicate modal
                $scope.settingsMenu = function (index) {
                    //initialize toggle
                    if (typeof $scope.duplicateSettings[index] === 'undefined') {
                        $scope.duplicateSettings[index] = false;
                    }
                    $scope.duplicateSettings[index] = !$scope.duplicateSettings[index];
                };

                $scope.cancelDuplicate = function () {
                    $scope.duplicateModal = !$scope.duplicateModal;
                };

                $scope.createNew = function () {
                    $scope.connections.data.emailStatus = 'createNew';
                    $scope.connections.data.emailId = '';
                    $scope.connections.data.emailName = '';

                    $scope.modalWindow = false;
                    $scope.selectedView = false;
                    $rootScope.editorSubMenu = false;
                    $scope.connections.emailData = {
                        EmailName: '',
                        FromName: $rootScope.emptyEmail.FromName,
                        FromEmail: $rootScope.emptyEmail.FromEmail,
                        ReplyEmail:  $rootScope.emptyEmail.ReplyEmail,
                        PermissionReminderMessage: $rootScope.emptyEmail.PermissionReminderMessage,
                        GoogleAnalyticsCampaign: '',
                        Subject: '',
                        TemplateContent: '',
                        InboxPreviewText: '',
                        ToListId: '',
                        ToListName: '',
                        WebpageVersion: true
                    };

                    $rootScope.$emit('displayActionSendEmailModal', $scope.connections, true, false);

                };

                $scope.insertExisting = function (emailId, fromEditor, emailName = 'Copy') {
                    $scope.isFromEditor = fromEditor;
                    $scope.currentDuplicateEmailId = emailId;
                    $scope.duplicateName = emailName + ' Copy';
                    $scope.duplicateModal = !$scope.duplicateModal;
                };

                $scope.displayModal = function () {
                    $scope.loadEmailListAsync();
                    $scope.loadTrashEmailListAsync();
                    var canvasEl = document.querySelector(".canvas");
                    $scope.modalLeft = (canvasEl.offsetLeft * -1) + 200;
                    $scope.modalTop = canvasEl.offsetTop * -1.0050;
                    $scope.selectedView = false;
                    $scope.contMenu = 0;
                    $scope.modalWindow = true;
                };

                $scope.displaySearchInput = (show) => {
                    let input = document.getElementById ("search-email");
                    $scope.displaySearch = show;
                    $scope.search.email = '';

                    input.focus();
                };

                $scope.contMenu = 0;
                $scope.validClickingArea = function() {
                    $scope.contMenu = 0;
                };
                $scope.$on('hideActionSendEmailModal', function() {
                    if($scope.modalWindow) {
                        if ($scope.contMenu === 0) {
                            $scope.contMenu = 1;
                        }else {
                            $scope.hideModal();
                            $scope.contMenu = 0;
                        }
                    }else {
                        $scope.contMenu = 0;
                    }
                });

                $scope.listView = true;
                $scope.toggleEmailsView = (display) => {
                    $scope.listView = display;
                };

                $scope.loadTrashEmailListAsync = () => {
                    if(!$rootScope.trashList) {
                        canvasService.getTrashEmails().then(({data}) => {
                            $rootScope.trashList = data.Results;
                            $rootScope.trashCount = data.Results && data.Results.length || 0;
                        });
                    }
                };

                $scope.loadEmailListAsync = function() {
                    if (!$rootScope.emailData) {
                        $rootScope.$emit('jbLoader', true, true);
                        canvasService
                            .getEmailList(0,15)
                            .success((data) => {
                                if(!data.Results.length) {
                                    $scope.createNew();
                                    $scope.hideModal();
                                    $rootScope.emailData = [];
                                } else {
                                    $rootScope.emailData = data.Results;
                                    $scope.emailList = $rootScope.emailData;
                                    $scope.setScrollLogic($scope.connections.id);
                                    $scope.modalWindow = true;
                                }
                                $rootScope.$emit('jbLoader', false, true);
                            })
                            .catch(() => {
                                $rootScope.$emit('jbLoader', false, true);
                            });
                    } else {
                        $scope.emailList = $rootScope.emailData;
                        $scope.setScrollLogic($scope.connections.id);
                        if(!$scope.emailList.length) {
                            $scope.hideModal();
                            $scope.createNew();
                        } else {
                            $scope.modalWindow = true;
                        }
                    }
                };

                $scope.searching = false;
                $scope.search.search =  (val) => {
                    if(val && val.length > 0 && !$scope.searching) {
                        $scope.searching = true;
                        canvasService.searchEmails(val)
                            .then((res) => {
                                $scope.searching = false;
                                $scope.emailList = res.data.Results;
                            })
                            .catch(() => {
                                $scope.searching = false;
                            });
                    } else {
                        $scope.emailList = $rootScope.emailData;
                    }
                };

                if (!$rootScope.userEmailAddress) {
                    canvasService
                        .getUserEmailAddress()
                        .success(function (data) {
                            $rootScope.userEmailAddress = data.Results || [];
                            $scope.emailAddressList = $rootScope.userEmailAddress.map(function (obj) {
                                return obj.Email;
                            });
                        });
                }

                $scope.sortBy = function(val) {
                    $scope.sortList = val;
                };

                let inProcess = false;
                $scope.movedToTrash = false;
                $scope.moveToTrash = (eId) => {
                    if(!inProcess) {
                        inProcess = true;
                        canvasService.trashEmail(eId).then(() => {
                            const index = $rootScope.emailData.findIndex((i) => i.EmailTemplateId == eId);
                            const splicedEl = $rootScope.emailData.splice(index, 1);
                            $scope.emailList = $rootScope.emailData;

                            delete splicedEl.$$hashKey;
                            $rootScope.trashList.unshift(splicedEl[0]);
                            $rootScope.trashCount ++;
                        }).finally(() => {
                            inProcess = false;
                            $scope.movedToTrash = true;
                            $timeout(() => { $scope.movedToTrash = false; }, 2000);
                        });
                    }
                };

                $scope.restored = false;
                $scope.restoreEmail = (eId) => {
                    if(!inProcess) {
                        inProcess = true;
                        canvasService.restoreTrashEmail(eId).then(() => {
                            const index = $rootScope.trashList.findIndex((i) => i.EmailTemplateId == eId);
                            const splicedEl = $rootScope.trashList.splice(index, 1);
                            $rootScope.trashCount --;

                            delete splicedEl.$$hashKey;
                            $rootScope.emailData.unshift(splicedEl[0]);
                            $scope.emailList = $rootScope.emailData;
                        }).finally(() => {
                            inProcess = false;
                            $scope.restored = true;
                            $timeout(() => { $scope.restored = false; }, 2000);
                        });
                    }
                };

                $scope.displayPreviewForEmail = (eId) => {
                    $scope.modalWindow = false;
                    $scope.displayList = false;
                    $scope.search.email = "";

                    $rootScope.$emit('previewEmail', 'showEmailList', false, false, $scope.connections.id);
                    $("#dvPreviewContent").html("<div class=\"loading-animation\"><span></span><span></span><span></span><span></span></div>");

                    canvasService.getPreview(eId)
                        .then(function({data}) {
                            if (data.Response.ID) {
                                var obj = data.Response;
                                var content = obj.TemplateContent;
                                if (content.indexOf("<!-- /Footer Path -->") != -1) {
                                    content = content.substring(0, content.indexOf("<!-- /Footer Path -->"));
                                }
                                $("#dvPreviewContent").html("");
                                var iframe = document.createElement('iframe');
                                $(iframe).attr("id", "ifrPreviewContent");
                                $("div#dvPreviewContent").append(iframe);
                                iframe.contentWindow.document.open();
                                iframe.contentWindow.document.write(content);
                                iframe.contentWindow.document.close();
                            } else {
                                alert("Could not load Preview");
                            }
                        });

                    $rootScope.$on('closePreviewEmailShowModal' + $scope.connections.id, () => {
                        $scope.displayModal();
                    })
                };

                $scope.$watch('connections', (conn) => {
                    if(conn && conn.children && conn.children.length) {
                        $scope.disAllowDrag = helpers.validateDragging(conn);
                    } else if(conn && !conn.children) {
                        $scope.disAllowDrag = true;
                    }
                });
            }],
            link: function (scope, elem, attr) {
                // Detect if browser is firefox
                if (typeof InstallTrigger !== 'undefined') {
                    scope._timeout  = null;
                    angular.element(document.getElementsByClassName('send-email')).bind("scroll", () => {
                        var elementActions = angular.element(document.getElementsByClassName('send-email-form'));

                        elementActions.css({ 'margin-right': '10px' });

                        // Cancel timeout
                        if(scope._timeout) {
                            $timeout.cancel(scope._timeout);
                        }

                        scope._timeout = $timeout(() => {
                            scope._timeout = null;

                            elementActions.css({ 'margin-right': '0' });
                        }, 1000);
                    });
                }

                // scope data initialization
                scope.sortList = '-EmailTemplateCreatedDate';
                scope.displayList = false;
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.selectedView = false;
                $rootScope.editorSubMenu = false;
                scope.duplicateSettings = [];
                scope.duplicateModal = false;
                scope.duplicateName = '';
                scope.isFromEditor = false;
                scope.emailOptions = false;
                scope.wrapOptions = false;

                // when the directive is loaded from service
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;

                    var canvasEl = document.querySelector(".canvas");
                    scope.modalLeft = canvasEl.offsetLeft * -1.05;
                    scope.modalTop = canvasEl.offsetTop * -1.0090;

                    //load template
                    var template = $templateCache.get('actions/send-email');

                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    // Modal
                    var modalTemplate = $templateCache.get('actions/send-email-modal');

                    var modalContent = $compile(modalTemplate)(scope);
                    $('body').append(modalContent);

                    $rootScope.$on('activateErr_' + scope.connections.id, function(evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function(evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('errEngagement_' + scope.connections.id, function(evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;

                        $timeout(() => { scope.displayErrorBlink = false; }, 5000);
                    });

                    $rootScope.$on('saveActionSendEmailData' + scope.connections.id, function(evt, conn) {
                        scope.connections = angular.copy(conn);
                        scope.saveData();
                    });

                    $rootScope.$on('saveActionSendEmail' + scope.connections.id, function(evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    $rootScope.$on('displayModalSendEmail' + scope.connections.id, function() {
                        scope.displayModal();
                    });

                    $rootScope.$on('updateSendEmailConn' + scope.connections.id, function(evt, conn, selectedView) {
                        scope.connections = angular.copy(conn);
                        angular.extend(scope, {selectedView: selectedView});
                    });

                    if (!scope.connections.isDummy) {
                        scope.save();
                    }

                    if(scope.connections && scope.connections.children && scope.connections.children.length) {
                        $timeout(() => {
                            scope.disAllowDrag = helpers.validateDragging(scope.connections);
                        }, 1000)
                    } else if(scope.connections && !scope.connections.children) {
                        scope.disAllowDrag = true;
                    }

                    scope.isElegibleForUpdate = false;
                    scope.saveData(true);
                }

                // when the directive is clicked
                $(elem).click(function (evt) {
                    //getting the inital positon to not move the email list modal
                    $rootScope.nodeVerticalPos = evt;

                    var canvasEl = document.querySelector(".canvas"),
                        modalTop = (canvasEl.offsetTop * -1) + 100;

                    if($rootScope.isFireFox) {
                        modalTop = modalTop - 70;
                    }

                    scope.modalLeft = (canvasEl.offsetLeft * -1) + ((window.innerWidth/2) - 475);
                    scope.modalTop = modalTop;
                    scope.emailListLoader = false;

                    //load template
                    var template = $templateCache.get('actions/send-email'),
                        modalTemplate = $templateCache.get('actions/send-email-modal'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);

                    // start connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: (lastElement.type == 'RectangleConnection') ? (lastElement.top - 43) : lastElement.top,
                        left: lastElement.left + 250,
                        type: 'Action',
                        emailData: {
                            EmailName: '',
                            FromEmail: '',
                            FromName: '',
                            GoogleAnalyticsCampaign: '',
                            PermissionReminderMessage: scope.translate('canvas.action.sendEmail.permisionReminder1') + $rootScope.cSettings.ClientCompany + scope.translate('canvas.action.sendEmail.permisionReminder2'),
                            ReplyEmail: '',
                            Subject: '',
                            TemplateContent: '',
                            InboxPreviewText: '',
                            ToListId: 0,
                            ToListName: '',
                            WebpageVersion: true
                        },
                        data: {
                            pageTextTextareas: false,
                            googleAnalyticsAllUrl: false,
                            editorType: '',
                            permisionReminder: true
                        },
                        elemClass: attr.$attr,
                        elemName: 'SendMail',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#B21877'
                    };

                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);


                        var modalContent = $compile(modalTemplate)(scope);
                        $(elem).parents('body').append(modalContent);
                    });

                    // keep track of what has been saved, for activation
                    $rootScope.unsavedData.push(scope.connections.id);


                    $rootScope.$on('activateErr_' + scope.connections.id, function(evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function(evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('errEngagement_' + scope.connections.id, function(evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;

                        $timeout(() => { scope.displayErrorBlink = false; }, 5000);
                    });

                    $rootScope.$on('saveUnsavedData' + scope.connections.id, function() {
                        scope.isElegibleForUpdate = false;
                        if(scope.connections.emailData.EmailName) {
                            scope.saveData();
                            scope.isElegibleForUpdate = true;
                        }
                    });

                    $rootScope.$on('saveActionSendEmailData' + scope.connections.id, function(evt, conn) {
                        scope.connections = angular.copy(conn);
                        scope.saveData();
                    });

                    $rootScope.$on('saveActionSendEmail' + scope.connections.id, function(evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    $rootScope.$on('displayModalSendEmail' + scope.connections.id, function() {
                        scope.displayModal();
                    });

                    $rootScope.$on('updateSendEmailConn' + scope.connections.id, function(evt, conn, selectedView) {
                        scope.connections = angular.copy(conn);
                        angular.extend(scope, {selectedView: selectedView});
                    });

                    scope.loadEmailListAsync();
                    scope.loadTrashEmailListAsync();

                    // Listener when user cancel the send email
                    $rootScope.$on('deleteSendEmailNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    // check if it comes from the editor to handle the return
                    if (scope.connections.data.emailStatus === 'fromEditor') {
                        scope.onRedirect();
                    }

                    // plumb service connect elements
                    plumbService.connectElements(lastElement, scope.connections);

                    $rootScope.$emit('closeMenus', true);
                });

                scope.setScrollLogic = function(id) {
                    scope.emailListLoader = false;
                    angular.element(
                        document.getElementById('listEmailContainer' + id)).bind("scroll",
                        function () {
                            if(!scope.emailListLoader && !$rootScope.stopLoadingEmailList && !scope.search.email) {
                                scope.emailListLoader = true;
                                canvasService.getEmailList($rootScope.emailListOffset, 5)
                                    .success(function(data) {
                                        if(!data.Results.length) {
                                            $rootScope.stopLoadingEmailList = true;
                                        }
                                        else {
                                            $rootScope.emailListOffset++;
                                            $rootScope.emailData = _.uniqBy($rootScope.emailData.concat(data.Results), 'EmailTemplateId');
                                            scope.emailList = $rootScope.emailData;
                                        }
                                        scope.emailListLoader = false;
                                    })
                                    .error(function() {
                                        scope.emailListLoader = false;
                                    })
                            }
                        }
                    );
                };

                scope.deleteElement = function () {
                    if($('.modal-email-form-' + scope.connections.id).length) {
                        $('.modal-email-form-' + scope.connections.id).remove();
                    }

                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;
                    plumbService.deleteElements(scope.connections);
                    $rootScope.$emit('emailDeleted',  scope.connections.id);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry' ) {
                        $rootScope.activePlus = true;
                    }else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function() {
                    if(scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
}());




// WEBPACK FOOTER //
// ./app/directives/canvas_directives/send-email-action.js